export default "__VITE_ASSET__9350902f__"